export function apiUrl() {
  return 'https://allread-server-duissport.tail4870e3.ts.net/api';
}

export function transitStorageWs() {
  return 'wss://allread-server-duissport.tail4870e3.ts.net/api/ws-comms';
}

export function authMethodsIndexes() {
  return '1';
}

export function thereIsClientLogo() {
  return 'true';
}

export function viewerLanguage() {
  return 'de';
}
